/* BrComfy motion + interaction layer (classic script, deferred).
   Scroll reveals, word splits, parallax, drag rails,
   quick-add size chips, shop-the-look drawer, collection view toggles. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var BRC = (window.BRC = window.BRC || {});

  var root = document.documentElement;

  /* ---------- scroll container ----------
     Fabric scrolls inside .page-wrapper on desktop (>=990px) and on the document on mobile.
     Listen to scroll in the capture phase so both are caught, and read the real offset. */
  var wide = window.matchMedia('(min-width: 990px)');
  function scroller() { return (wide.matches && document.querySelector('.page-wrapper')) || document.scrollingElement || root; }
  BRC.scroller = scroller;
  function lock(on) {
    if (on) root.setAttribute('scroll-lock', ''); else root.removeAttribute('scroll-lock');
    root.style.overflow = on ? 'hidden' : '';
  }
  BRC.lock = lock;

  /* ---------- header state ---------- */
  var ticking = false;
  function onScroll() {
    root.classList.toggle('brc-scrolled', scroller().scrollTop > 40);
    checkReveal();
    parallax();
    manifesto();
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t !== document && t !== root && !(t.classList && t.classList.contains('page-wrapper'))) return;
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () { ticking = false; onScroll(); });
  }, { capture: true, passive: true });

  /* ---------- word split ---------- */
  function split(el) {
    if (el.dataset.brcSplitDone) return;
    el.dataset.brcSplitDone = '1';
    var i = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
            var w = document.createElement('span'); w.className = 'w';
            var s = document.createElement('span'); s.textContent = part; s.style.setProperty('--i', i++);
            w.appendChild(s); frag.appendChild(w);
          });
          c.parentNode.replaceChild(frag, c);
        } else if (c.nodeType === 1 && !c.classList.contains('w')) walk(c);
      });
    })(el);
  }

  /* ---------- reveal on scroll (rect check, no IntersectionObserver dependency) ---------- */
  var pending = [];
  function checkReveal() {
    if (!pending.length) return;
    var vh = window.innerHeight || 800;
    pending = pending.filter(function (el) {
      if (!el.isConnected) return false;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.94 && r.bottom > -40) { el.classList.add('is-in'); return false; }
      return true;
    });
  }
  function initReveal(scope) {
    (scope || document).querySelectorAll('.brc-split').forEach(split);
    (scope || document).querySelectorAll('[data-brc-reveal], .brc-split').forEach(function (el) {
      if (reduce) { el.classList.add('is-in'); return; }
      if (pending.indexOf(el) < 0 && !el.classList.contains('is-in')) pending.push(el);
    });
    (scope || document).querySelectorAll('.brc-manifesto__text').forEach(function (el) {
      if (!el.dataset.brcSplitDone) { el.dataset.brcSplitDone = '1'; el.innerHTML = el.textContent.trim().split(/\s+/).map(function (w) { return '<span class="w">' + w + '</span>'; }).join(' '); }
    });
    checkReveal();
  }
  // safety net: never leave content hidden if scrolling events are throttled
  setInterval(checkReveal, 400);

  /* ---------- parallax ---------- */
  var plx = [];
  function collectParallax() { plx = Array.prototype.slice.call(document.querySelectorAll('[data-brc-parallax]')); }
  function parallax() {
    if (reduce) return;
    var vh = window.innerHeight;
    for (var i = 0; i < plx.length; i++) {
      var el = plx[i], r = el.parentElement.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) continue;
      var p = (r.top + r.height / 2 - vh / 2) / vh; // -1..1
      var amt = parseFloat(el.dataset.brcParallax) || 10;
      el.style.transform = 'translate3d(0,' + (p * -amt).toFixed(2) + '%,0)';
    }
  }

  /* ---------- manifesto word-by-word ---------- */
  function manifesto() {
    document.querySelectorAll('.brc-manifesto__text').forEach(function (el) {
      var r = el.getBoundingClientRect(), vh = window.innerHeight;
      var p = Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35)));
      var ws = el.querySelectorAll('.w'), n = Math.round(p * ws.length);
      for (var i = 0; i < ws.length; i++) ws[i].classList.toggle('on', i < n || reduce);
    });
  }

  /* ---------- drag rails ---------- */
  function initRails(scope) {
    (scope || document).querySelectorAll('.brc-rail').forEach(function (rail) {
      if (rail.dataset.brcRail) return; rail.dataset.brcRail = '1';
      var down = false, sx = 0, sl = 0, moved = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; sx = e.clientX; sl = rail.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; moved = Math.abs(dx); if (moved > 4) rail.classList.add('is-dragging'); rail.scrollLeft = sl - dx; });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { rail.classList.remove('is-dragging'); }, 0); });
      var nav = rail.parentElement && rail.parentElement.querySelector('[data-brc-rail-nav]');
      if (nav) nav.addEventListener('click', function (e) {
        var b = e.target.closest('button'); if (!b) return;
        rail.scrollBy({ left: (b.dataset.dir === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  }

  /* ---------- toast ---------- */
  var toastEl;
  BRC.toast = function (msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'brc-toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
  };

  /* ---------- quick add (size chips) ---------- */
  function addVariant(btn) {
    var id = btn.dataset.variantId; if (!id) return;
    btn.classList.add('is-loading');
    var done = function (ok) {
      btn.classList.remove('is-loading');
      if (ok) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
      var card = btn.closest('.brc-card'); if (card) card.classList.remove('is-open');
      var sheet = btn.closest('.brc-drawer'); if (ok && sheet) setTimeout(function () { BRC.closeDrawer(sheet); }, 350);
    };
    var go = function () {
      BRC.add(id, 1).then(function () { done(true); }).catch(function (err) { done(false); BRC.toast((err && err.message) || 'Could not add that size'); });
    };
    if (BRC.add) go(); else document.addEventListener('brc:cart-ready', go, { once: true });
  }
  document.addEventListener('click', function (e) {
    var plus = e.target.closest('.brc-card__plus');
    if (plus) {
      e.preventDefault();
      var card = plus.closest('.brc-card');
      var single = card.querySelectorAll('.brc-card__sizes [data-variant-id]:not([disabled])');
      if (single.length === 1 && card.dataset.singleVariant === 'true') { addVariant(single[0]); return; }
      document.querySelectorAll('.brc-card.is-open').forEach(function (c) { if (c !== card) c.classList.remove('is-open'); });
      card.classList.toggle('is-open');
      return;
    }
    var chip = e.target.closest('[data-brc-add]');
    if (chip && !chip.disabled) { e.preventDefault(); addVariant(chip); return; }
    if (!e.target.closest('.brc-card')) document.querySelectorAll('.brc-card.is-open').forEach(function (c) { c.classList.remove('is-open'); });
  });

  /* ---------- generic drawer (shop the look) ---------- */
  BRC.openDrawer = function (drawer) {
    if (!drawer) return;
    // fixed overlays must live on <body>: transformed ancestors (reveals, parallax) break position: fixed
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    drawer.classList.add('is-open');
    void drawer.offsetWidth; drawer.classList.add('is-shown');
    drawer._last = document.activeElement;
    var f = drawer.querySelector('.brc-drawer__close'); if (f) f.focus();
    lock(true);
  };
  BRC.closeDrawer = function (drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-shown');
    setTimeout(function () { drawer.classList.remove('is-open'); lock(false); if (drawer._last) drawer._last.focus(); }, 450);
  };
  document.addEventListener('click', function (e) {
    var look = e.target.closest('[data-brc-look]');
    if (look) {
      e.preventDefault();
      var tpl = document.getElementById(look.dataset.brcLook);
      var drawer = document.getElementById('brc-look-drawer');
      if (tpl && drawer) {
        drawer.querySelector('[data-brc-look-title]').textContent = look.dataset.title || 'Shop the look';
        drawer.querySelector('[data-brc-look-body]').innerHTML = tpl.innerHTML;
        BRC.openDrawer(drawer);
      }
      return;
    }
    if (e.target.closest('[data-brc-drawer-close]')) { BRC.closeDrawer(e.target.closest('.brc-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var d = document.querySelector('.brc-drawer.is-open'); if (d) BRC.closeDrawer(d); document.querySelectorAll('.brc-card.is-open').forEach(function (c) { c.classList.remove('is-open'); }); }
  });

  /* ---------- collection view toggles ---------- */
  function initColTools() {
    var bar = document.querySelector('[data-brc-coltools]'); if (!bar || bar.dataset.ready) return; bar.dataset.ready = '1';
    var main = document.querySelector('main') || document.body;
    var saved = {}; try { saved = JSON.parse(localStorage.getItem('brc-col') || '{}'); } catch (e) {}
    var back = bar.querySelector('[data-brc-back]');
    function applyBack(on) {
      document.querySelectorAll('.product-grid .card-gallery slideshow-component, .product-grid slideshow-component').forEach(function (s) {
        try { if (typeof s.select === 'function') s.select(on ? 1 : 0, undefined, { animate: false }); } catch (e) {}
      });
      document.body.classList.toggle('brc-show-back', on);
    }
    if (back) {
      back.checked = !!saved.back; if (saved.back) setTimeout(function () { applyBack(true); }, 600);
      back.addEventListener('change', function () { saved.back = back.checked; applyBack(back.checked); try { localStorage.setItem('brc-col', JSON.stringify(saved)); } catch (e) {} });
    }
    bar.querySelectorAll('[data-brc-density] button').forEach(function (b) {
      var set = function (v) { main.setAttribute('data-brc-density', v); bar.querySelectorAll('[data-brc-density] button').forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.v === v)); }); };
      if (saved.d && b.dataset.v === saved.d) set(saved.d);
      b.addEventListener('click', function () { saved.d = b.dataset.v; set(b.dataset.v); try { localStorage.setItem('brc-col', JSON.stringify(saved)); } catch (e) {} });
    });
    // keep the back view after filters re-render the grid
    new MutationObserver(function () { if (back && back.checked) applyBack(true); }).observe(main, { childList: true, subtree: true });
  }

  /* ---------- mobile menu (replaces Fabric's drawer below 990px) ---------- */
  var menu = null;
  function openMenu() {
    menu = menu || document.getElementById('brc-menu'); if (!menu) return false;
    menu.hidden = false; menu._last = document.activeElement;
    void menu.offsetWidth; menu.classList.add('is-open');
    lock(true);
    var c = menu.querySelector('[data-brc-menu-close]'); if (c) c.focus({ preventScroll: true });
    return true;
  }
  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.classList.remove('is-open'); lock(false);
    setTimeout(function () { menu.hidden = true; }, 420);
    if (menu._last && menu._last.focus) menu._last.focus({ preventScroll: true });
  }
  BRC.openMenu = openMenu; BRC.closeMenu = closeMenu;
  window.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.header__icon--menu');
    if (t && !wide.matches && document.getElementById('brc-menu')) {
      e.preventDefault(); e.stopImmediatePropagation();
      var d = t.closest('details'); if (d) d.removeAttribute('open');
      openMenu();
      return;
    }
    if (e.target.closest && e.target.closest('[data-brc-menu-close]')) { e.preventDefault(); closeMenu(); }
    if (menu && !menu.hidden && e.target.closest && e.target.closest('.brc-menu a[href*="#"]')) closeMenu();
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  wide.addEventListener('change', function () { if (wide.matches) closeMenu(); });

  /* ---------- hero product stage (auto-rotating) ---------- */
  function initHero(scope) {
    (scope || document).querySelectorAll('[data-brc-hero]').forEach(function (stage) {
      if (stage.dataset.ready) return; stage.dataset.ready = '1';
      var slides = stage.querySelectorAll('[data-brc-hero-slide]'); if (slides.length < 2) return;
      var dots = stage.querySelectorAll('[data-brc-hero-dot]'), count = stage.querySelector('[data-brc-hero-count]');
      var i = 0, timer = null;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
        if (count) count.textContent = (i < 9 ? '0' : '') + (i + 1);
        stage.style.setProperty('--brc-hero-i', i);
      }
      function play() { stop(); if (!reduce) timer = setInterval(function () { show(i + 1); }, 4200); }
      function stop() { if (timer) clearInterval(timer); timer = null; }
      dots.forEach(function (d) { d.addEventListener('click', function () { show(+d.dataset.brcHeroDot); play(); }); });
      stage.addEventListener('pointerenter', stop); stage.addEventListener('pointerleave', play);
      var sx = null;
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) { show(i + (dx < 0 ? 1 : -1)); play(); } sx = null; });
      play();
    });
  }


  /* ---------- shop tabs (category rails) ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-brc-tab]'); if (!tab) return;
    var root = tab.closest('[data-brc-tabs]'), i = tab.dataset.brcTab;
    root.querySelectorAll('[data-brc-tab]').forEach(function (t) { t.setAttribute('aria-selected', String(t === tab)); });
    root.querySelectorAll('[data-brc-panel]').forEach(function (p) { p.hidden = p.dataset.brcPanel !== i; });
    var panel = root.querySelector('[data-brc-panel="' + i + '"]'); if (panel) { initReveal(panel); var r = panel.querySelector('.brc-rail'); if (r) r.scrollLeft = 0; }
  });

  /* ---------- card colour swatches ---------- */
  function pickSwatch(sw, commit) {
    var card = sw.closest('.brc-card'); if (!card) return;
    var img = card.querySelector('.brc-card__front');
    if (img && sw.dataset.img) {
      if (!img.dataset.orig) { img.dataset.orig = img.currentSrc || img.src; img.dataset.origSet = img.getAttribute('srcset') || ''; }
      img.removeAttribute('srcset'); img.src = sw.dataset.img;
    }
    card.classList.add('brc-card--swatched');
    if (!commit) return;
    card.querySelectorAll('[data-brc-swatch]').forEach(function (b) { var on = b === sw; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', String(on)); });
    card.querySelectorAll('[data-brc-sizeset]').forEach(function (set) { set.hidden = set.dataset.brcSizeset !== sw.dataset.brcSwatch; });
    if (sw.dataset.url) card.querySelectorAll('a.brc-card__media, a.brc-card__title').forEach(function (a) { a.href = sw.dataset.url; });
    card._sw = sw;
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-brc-swatch]'); if (!sw) return;
    e.preventDefault(); pickSwatch(sw, true);
  });
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest && e.target.closest('[data-brc-swatch]'); if (sw) pickSwatch(sw, false);
  });
  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var sw = e.target.closest && e.target.closest('[data-brc-swatch]'); if (!sw) return;
    var card = sw.closest('.brc-card'); if (!card || (e.relatedTarget && sw.parentNode.contains(e.relatedTarget))) return;
    if (card._sw) pickSwatch(card._sw, false);
    else { var img = card.querySelector('.brc-card__front'); if (img && img.dataset.orig) { img.src = img.dataset.orig; if (img.dataset.origSet) img.setAttribute('srcset', img.dataset.origSet); } card.classList.remove('brc-card--swatched'); }
  });

  /* ---------- recently viewed ---------- */
  var RV_KEY = 'brc-rv';
  function rvRead() { try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) { return []; } }
  function rvWrite(list) { try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12))); } catch (e) {} }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* Formats cents like Liquid's money_without_trailing_zeros, using a sample rendered by the server in the
     active currency (window.BRC_MONEY_SAMPLE is 123456 cents, e.g. "£1,234.56" or "Rs. 1,234.56"). */
  function money(cents) {
    var s = window.BRC_MONEY_SAMPLE || '';
    var m = s.match(/^(\D*)1(\D?)234(\D)56(\D*)$/);
    var v = Math.round(cents) / 100, whole = Math.floor(v), frac = Math.round((v - whole) * 100);
    if (!m) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: window.BRC_CUR || 'GBP', minimumFractionDigits: frac ? 2 : 0 }).format(v); } catch (e) { return String(v); } }
    var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
    return m[1] + w + (frac ? m[3] + (frac < 10 ? '0' : '') + frac : '') + m[4];
  }
  function rvRefresh(sec, items) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var list = rvRead(), changed = false;
    items.forEach(function (p) {
      fetch(root + 'products/' + encodeURIComponent(p.handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var el = sec.querySelector('[data-brc-rv-price="' + p.handle + '"]');
          if (!j) { if (el && p.cur !== window.BRC_CUR) el.textContent = ''; return; }
          var txt = money(j.price);
          if (j.compare_at_price && j.compare_at_price > j.price) txt += ' <s class="brc-card__was">' + money(j.compare_at_price) + '</s> <span class="brc-off">-' + Math.round((j.compare_at_price - j.price) * 20 / j.compare_at_price) * 5 + '%</span>';
          if (el) el.innerHTML = txt;
          list = rvRead();
          list.forEach(function (x) { if (x.handle === p.handle) { x.price = txt; x.cents = j.price; x.cur = window.BRC_CUR; x.available = j.available; changed = true; } });
          if (changed) rvWrite(list);
        })
        .catch(function () {});
    });
  }
  function rvCard(p) {
    var sizes = (p.sizes || []).map(function (v) { return '<button class="brc-chip" type="button" data-brc-add data-variant-id="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + esc(v.label) + '</button>'; }).join('');
    return '<div><article class="brc-card"><div class="brc-card__top"><a href="' + esc(p.url) + '" class="brc-card__media" aria-label="' + esc(p.title) + '">' +
      '<img class="brc-card__front' + (p.back ? ' has-back' : '') + '" src="' + esc(p.img) + '" alt="' + esc(p.title) + '" loading="lazy">' +
      (p.back ? '<img class="brc-card__back" src="' + esc(p.back) + '" alt="" loading="lazy">' : '') + '</a>' +
      (p.available && sizes ? '<div class="brc-card__sizes" role="group" aria-label="Choose a size"><div class="brc-card__sizeset">' + (p.colour ? '<span class="brc-card__sizes-label">' + esc(p.colour) + '</span>' : '') + sizes + '</div></div>' : '') +
      '</div><div class="brc-card__meta"><a class="brc-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="brc-card__price" data-brc-rv-price="' + esc(p.handle) + '">' + (p.cur && p.cur === window.BRC_CUR ? p.price : '') + '</span>' +
      (p.available && sizes ? '<button class="brc-card__plus" type="button" aria-label="Quick add ' + esc(p.title) + '" aria-expanded="false">+</button>' : '') + '</div></article></div>';
  }
  function initRecent() {
    var data = document.querySelector('[data-brc-recent-product]'), current = null;
    if (data) {
      try { current = JSON.parse(data.textContent); } catch (e) {}
      if (current && current.handle) {
        var l = rvRead().filter(function (x) { return x.handle !== current.handle; });
        l.unshift(current); rvWrite(l);
      }
    }
    document.querySelectorAll('[data-brc-recent]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var limit = +sec.dataset.limit || 8;
      var items = rvRead().filter(function (x) { return !current || x.handle !== current.handle; }).slice(0, limit);
      if (!items.length) { sec.hidden = true; return; }
      sec.querySelector('[data-brc-recent-list]').innerHTML = items.map(rvCard).join('');
      sec.hidden = false; initRails(sec); rvRefresh(sec, items);
      var clr = sec.querySelector('[data-brc-recent-clear]');
      if (clr) clr.addEventListener('click', function () { rvWrite([]); sec.hidden = true; });
    });
  }

  /* ---------- reviews ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-brc-review-open]');
    if (open) {
      var f = document.getElementById(open.getAttribute('aria-controls'));
      if (f) { f.hidden = !f.hidden; open.setAttribute('aria-expanded', String(!f.hidden)); if (!f.hidden) { var first = f.querySelector('input:not([type=hidden]), textarea'); if (first) first.focus({ preventScroll: false }); } }
      return;
    }
    var more = e.target.closest('[data-brc-review-more]');
    if (more) { more.closest('.brc-reviews').classList.add('is-all'); more.remove(); }
  });

  /* ---------- review wall: star line under the title, jump to reviews, see all, photo zoom ---------- */
  function syncStarline() {
    var wall = document.querySelector('[data-brc-review-wall]');
    var n = wall ? parseInt(wall.getAttribute('data-count'), 10) || 0 : 0;
    document.querySelectorAll('[data-brc-starline]').forEach(function (a) {
      if (!n) { if (!a.hidden) a.hidden = true; return; }
      var stars = a.querySelector('.brc-stars'), txt = a.querySelector('[data-brc-starline-text]');
      var rating = wall.getAttribute('data-rating'), label = rating + ' · ' + n + ' review' + (n === 1 ? '' : 's');
      stars.style.setProperty('--pct', wall.getAttribute('data-pct') + '%');
      stars.setAttribute('aria-label', rating + ' out of 5 stars');
      if (txt.textContent !== label) txt.textContent = label;
      if (a.hidden) a.hidden = false;
    });
  }
  syncStarline();
  document.addEventListener('DOMContentLoaded', syncStarline);
  document.addEventListener('shopify:section:load', syncStarline);
  (function () {
    /* the product section is re-rendered when a variant is picked, which hides the line again */
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncStarline(); });
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden', 'data-count'] });
  })();
  function initReviewSliders() {
    document.querySelectorAll('[data-brc-rw-slider]:not([data-ready])').forEach(function (el) {
      el.setAttribute('data-ready', '');
      var track = el.querySelector('.brc-rw__track'), slides = track.children;
      var prev = el.querySelector('[data-brc-rw-nav="-1"]'), next = el.querySelector('[data-brc-rw-nav="1"]'), idx = el.querySelector('[data-brc-rw-index]');
      function update() {
        var w = track.clientWidth;
        if (!w) return;
        var i = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
        var h = slides[i].offsetHeight;
        if (h) track.style.height = h + 'px';
        idx.textContent = i + 1;
        prev.disabled = i === 0;
        next.disabled = i === slides.length - 1;
      }
      var t;
      track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(update, 80); }, { passive: true });
      el.addEventListener('click', function (e) {
        var b = e.target.closest('[data-brc-rw-nav]');
        if (b) track.scrollBy({ left: Number(b.getAttribute('data-brc-rw-nav')) * track.clientWidth, behavior: 'smooth' });
      });
      el.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', update); });
      if (window.ResizeObserver) new ResizeObserver(update).observe(el);
      update();
    });
  }
  initReviewSliders();
  document.addEventListener('DOMContentLoaded', initReviewSliders);
  document.addEventListener('shopify:section:load', initReviewSliders);
  /* ---------- cart drawer: free-delivery progress (threshold is in shop currency, converted here) ---------- */
  function syncShipBar() {
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    document.querySelectorAll('[data-brc-ship]').forEach(function (el) {
      var threshold = Math.round(Number(el.getAttribute('data-threshold')) * rate), total = Number(el.getAttribute('data-total')) || 0;
      var gap = threshold - total, txt = el.querySelector('[data-brc-ship-text]'), bar = el.querySelector('[data-brc-ship-bar]'), html;
      if (gap <= 0) {
        html = '<b>Free delivery unlocked.</b>';
      } else {
        var gapShop = gap / rate / 100, hint = el.getAttribute('data-hint'), teeMod = el.getAttribute('data-tee-mod'), how;
        if (hint === 'women') how = gapShop <= 40 ? 'Add a top or a skirt and you\'re there.' : 'Add a hoodie or knit and you\'re there.';
        else if (hint === 'bottom' && gapShop <= 38) how = 'Add any bottom and you\'re there.';
        else if (teeMod === '1' && gapShop <= 38) how = 'Add another tee and you\'re there.';
        else if (gapShop <= 38) how = 'Add a tee and you\'re there.';
        else if (gapShop <= 55) how = hint === 'bottom' ? 'Add joggers or a sweatshirt and you\'re there.' : 'Add a sweatshirt or joggers and you\'re there.';
        else how = 'Add a top and a bottom and you\'re there.';
        html = '<b>' + money(Math.ceil(gap / 100) * 100) + '</b> away from free delivery. ' + how;
      }
      if (txt.innerHTML !== html) txt.innerHTML = html;
      var w = Math.max(4, Math.min(100, Math.round(total / threshold * 100))) + '%';
      if (bar.style.width !== w) bar.style.width = w;
      el.classList.toggle('is-free', gap <= 0);
      if (el.hidden) el.hidden = false;
    });
  }
  function syncFreeShipLines() {
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    document.querySelectorAll('[data-brc-freeship]').forEach(function (el) {
      var span = el.querySelector('span');
      if (!span || span.textContent) return;
      span.textContent = money(Math.ceil(Number(el.getAttribute('data-brc-freeship')) * rate / 100) * 100);
      el.hidden = false;
    });
  }
  function syncGiftLine() {
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    document.querySelectorAll('[data-brc-gift]').forEach(function (el) {
      var total = Number(el.getAttribute('data-total')) || 0, gift = el.getAttribute('data-gift');
      var tee = Math.round(Number(el.getAttribute('data-tee')) * rate), hoodie = Math.round(Number(el.getAttribute('data-hoodie')) * rate);
      var up = function (c) { return money(Math.ceil(c / 100) * 100); }, html;
      if (gift === 'hoodie') html = '<b>Big Bag Gift.</b> Your hoodie is free.';
      else if (total >= hoodie) html = '<b>Big Bag Gift.</b> You\'re past ' + up(hoodie) + '. Add any hoodie and it\'s free.';
      else if (gift === 'tee') html = '<b>Big Bag Gift.</b> Your tee is free. ' + up(hoodie - total) + ' more and a hoodie is free instead.';
      else if (total >= tee) html = '<b>Big Bag Gift.</b> You\'re past ' + up(tee) + '. Add any tee and it\'s free.';
      else html = '<b>Big Bag Gift.</b> ' + up(tee - total) + ' more and your next tee is free. At ' + up(hoodie) + ', a hoodie.';
      if (el.innerHTML !== html) el.innerHTML = html;
      if (el.hidden) el.hidden = false;
    });
  }
  syncShipBar();
  syncFreeShipLines();
  syncGiftLine();
  document.addEventListener('DOMContentLoaded', function () { syncShipBar(); syncFreeShipLines(); syncGiftLine(); });
  (function () {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; syncShipBar(); syncGiftLine(); });
    }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-total', 'hidden'] });
  })();
  var lightbox;
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('a[href="#reviews"]');
    if (jump) {
      var target = document.getElementById('reviews');
      if (!target || target.hidden) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      return;
    }
    var all = e.target.closest('[data-brc-rw-more]');
    if (all) { all.closest('.brc-rw').classList.add('is-all'); all.parentNode.remove(); return; }
    var zoom = e.target.closest('[data-brc-lightbox]');
    if (zoom && window.HTMLDialogElement) {
      if (!lightbox) {
        lightbox = document.createElement('dialog');
        lightbox.className = 'brc-lightbox';
        lightbox.innerHTML = '<button type="button" aria-label="Close photo">&times;</button><img alt="">';
        document.body.appendChild(lightbox);
        lightbox.addEventListener('click', function (ev) { if (ev.target.tagName !== 'IMG') lightbox.close(); });
      }
      var big = lightbox.querySelector('img'), small = zoom.querySelector('img');
      big.src = zoom.getAttribute('data-brc-lightbox');
      big.alt = small ? small.alt : '';
      lightbox.showModal();
    }
  });

  /* ---------- fit text to its container width (footer wordmark) ---------- */
  function fitText() {
    document.querySelectorAll('[data-brc-fit]').forEach(function (el) {
      var box = el.parentElement, cs = getComputedStyle(box);
      var avail = box.clientWidth - parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
      el.style.fontSize = '100px';
      var w = el.scrollWidth; if (!w) return;
      el.style.fontSize = Math.floor(100 * avail / w * 0.995) + 'px';
    });
  }
  window.addEventListener('resize', fitText);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitText);

  /* ---------- boot ---------- */
  function boot(scope) { fitText(); initHero(scope); initRecent(); initReveal(scope); initRails(scope); collectParallax(); parallax(); manifesto(); initColTools(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
/* ---------- campaigns: countdowns and cart spend tiers ---------- */
(function () {
  function camp(id) { return window.BRC_CAMPAIGNS && BRC_CAMPAIGNS[id]; }
  function tick() {
    document.querySelectorAll('[data-brc-clock]').forEach(function (el) {
      var c = camp(el.getAttribute('data-brc-clock')); if (!c) return;
      var ms = Math.max(0, Date.parse(c.end) - Date.now()), v = { d: Math.floor(ms / 864e5), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
      el.querySelectorAll('[data-u]').forEach(function (b) { var t = String(v[b.getAttribute('data-u')]).padStart(2, '0'); if (b.textContent !== t) b.textContent = t; });
    });
    document.querySelectorAll('[data-brc-countdown]').forEach(function (el) {
      var c = camp(el.getAttribute('data-brc-countdown')); if (!c) return;
      var to = el.getAttribute('data-brc-until') === 'start' ? c.start : c.end;
      var ms = Math.max(0, Date.parse(to) - Date.now()), d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
      var t = (d ? d + 'd ' : '') + String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
      if (el.textContent !== t) el.textContent = t;
    });
  }
  function money(cents) {
    var cur = window.BRC_CUR || 'GBP';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); } catch (e) { return (cents / 100).toFixed(2); }
  }
  function tiers() {
    var c = camp(window.BRC_CAMP); if (!c || !c.tiers || !c.tiers.length) return;
    var rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    document.querySelectorAll('[data-brc-tiers]').forEach(function (el) {
      var total = Number(el.getAttribute('data-total')) || 0, count = Number(el.getAttribute('data-count')) || 0, html, got = null, next = null, L = '<b>' + c.label + '.</b> ';
      if (c.mode === 'qty') {
        // tier = [min items, % off, optional extra £ off in pence]
        c.tiers.forEach(function (t) { if (count >= t[0]) got = t; else if (!next) next = t; });
        var xm = function (p) { return money(Math.round(p * rate / 100) * 100); };
        var gotTxt = got ? got[1] + '% off' + (got[2] ? ' + ' + xm(got[2]) + ' off' : '') : '';
        var nextTxt = next ? (next[2] && got && next[1] === got[1] ? 'an extra ' + xm(next[2]) + ' off' : next[1] + '% off' + (next[2] ? ' + ' + xm(next[2]) + ' off' : '')) : '';
        if (next) html = L + 'Add ' + (next[0] - count) + ' more item' + (next[0] - count > 1 ? 's' : '') + ' and get ' + nextTxt + '.' + (got ? ' You\'re getting ' + gotTxt + ' now.' : '');
        else html = L + 'Top deal unlocked: ' + gotTxt + ' at checkout.';
      } else {
        c.tiers.forEach(function (t) { var min = Math.round(t[0] * rate), off = Math.round(t[1] * rate / 100) * 100; if (total >= min) got = off; else if (!next) next = [min, off]; });
        if (next) html = L + 'Add ' + money(Math.ceil((next[0] - total) / 100) * 100) + ' more and save ' + money(next[1]) + '.' + (got ? ' You\'re saving ' + money(got) + ' now.' : '');
        else html = L + 'Top tier unlocked: ' + money(got) + ' off at checkout.';
      }
      if (el.innerHTML !== html) el.innerHTML = html;
      el.hidden = false;
    });
  }
  tick(); setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', function () { tick(); tiers(); });
  var q = false;
  new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; tiers(); }); }).observe(document.documentElement, { childList: true, subtree: true });
})();
/* ---------- Pre-Black Friday: sale panel under the product price ---------- */
(function () {
  function addPanel() {
    var c = window.BRC_CAMPAIGNS && BRC_CAMPAIGNS[window.BRC_CAMP];
    if (!c || location.pathname.indexOf('/products/') === -1) return;
    var info = document.querySelector('.product-information, [id$="__product-information"]'); if (!info) return;
    var price = info.querySelector('product-price, .price');
    var scope = price && price.closest('.group-block, .text-block, [class*="group"]');
    if ((!price && !document.querySelector('.brc-pdeals-block')) || document.querySelector('.brc-camp-pdp')) return;
    var el = document.createElement('div');
    el.className = 'brc-camp-pdp';
    el.innerHTML = '<b>' + c.label + '</b><div>' + c.panel + '</div><span>Ends in <b data-brc-countdown="' + window.BRC_CAMP + '">–</b></span>';
    var box = document.querySelector('.brc-pdeals-block');
    if (box) box.insertAdjacentElement('afterbegin', el); else (scope || price).insertAdjacentElement('afterend', el);
  }
  addPanel(); document.addEventListener('DOMContentLoaded', addPanel);
})();